<template>
  <div class="main">
    <van-nav-bar title="选择支付方式" left-arrow @click-left="onClickLeft" />
    <div class="head">
      <div class="share pay-time">
        <van-row>
          <van-col>支付剩余时间</van-col>
          <van-col>
            <van-count-down :time="time" />
          </van-col>
        </van-row>
      </div>
      <div class="share">￥{{ params.payAmount }}元</div>
      <div class="share">{{ params.storeName }}</div>
    </div>
    <div class="select">
      <van-radio-group @change="radioChange" v-model="radio">
        <van-cell-group>
          <van-cell title="微信小程序支付" clickable @click="radio = '1'">
            <template #icon="props">
              <img class="img-icon" src="@/assets/images/puhui/wx.png" />
            </template>
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
          <van-cell title="工商银行聚富通支付" clickable @click="radio = '2'">
            <template #icon="props">
              <img class="img-icon" src="@/assets/images/puhui/gonghang.png" />
            </template>
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="btn">
      <van-button @click="btnConfirm" class="btn-content" type="warning">
        确认支付</van-button
      >
    </div>
  </div>
</template>

<script>
import { toPayV2 } from '@/api/productsDetaile'
import { FRONTEND_HOST } from '@/config/domainnameconstant'
import moment from 'moment'
export default {
  data() {
    return {
      toPayRequestVo: {},
      params: {},
      radio: 0,
      time: 0,
    }
  },
  created() {
    this.params = this.$route.query
    console.log('this.params', this.params)
    let a = moment().format('YYYY-MM-DD HH:mm:ss')
    let b = moment(this.params.orderOvertime)
    let c = b.diff(a, 'seconds')
    console.log(c)
    this.time = c * 1000
  },
  mounted() {
    if (this.time === 0) {
      let orderId = {
        orderId: this.params.orderId,
        deliveryMethod: this.params.deliveryMethod,
      }
      this.$callApp('Android', 'GoOrderDetailMethod ', JSON.stringify(orderId))
      this.$callApp('iOS', 'GoOrderDetailMethod', orderId)
    }
  },
  methods: {
    onClickLeft() {
      let orderId = {
        orderId: this.params.orderId,
        deliveryMethod: this.params.deliveryMethod,
      }
      console.log('JSON.stringify(orderId)', JSON.stringify(orderId))
      this.$callApp('Android', 'GoOrderDetailMethod', this.params.orderId)
      this.$callApp('iOS', 'GoOrderDetailMethod', orderId)
    },
    radioChange(val) {
      console.log(val)
      this.radio = val
      if (this.radio === '1') {
        this.toPayRequestVo = {
          orderId: this.params.orderId,
          payType: '7',
        }
      }
      if (this.radio === '2') {
        this.toPayRequestVo = {
          orderId: this.params.orderId,
          payType: '11',
        }
      }
    },
    btnConfirm() {
      const loading = this.$toast.loading({
        overlay: true,
        forbidClick: true,
        duration: 0,
        message: '加载中...',
      })
      toPayV2(this.toPayRequestVo)
        .then((res) => {
          if (res.data.code === 200) {
            let payData = {
              payData: res.data.data.payData,
              orderId: res.data.data.orderId,
              certificationType: res.data.data.certificationType,
              payType: res.data.data.payType,
              orderSn: res.data.data.orderSn,
              orderType: 1,
            }
            if (res.data.data.needPay) {
              if (this.radio === '1') {
                let successReturnUrl = ``
                let failReturnUrl = ``
                successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
                failReturnUrl = `${FRONTEND_HOST}/themepage/error?id=${payData.orderId}`
                let orderMsg = {
                  orderNo: payData.orderSn,
                  successReturnUrl: successReturnUrl,
                  failReturnUrl: failReturnUrl,
                  orderType: 1,
                  orderId: payData.orderId,
                }
                console.log('测试安卓1111111111111111111111111111')
                this.$callApp(
                  'Android',
                  'ICBWXPayMethod',
                  JSON.stringify(orderMsg)
                )
                this.$callApp('iOS', 'ICBWXPayMethod', JSON.stringify(orderMsg))
                console.log('工行微信11111111111111111111111111', orderMsg)
              }
              if (this.radio === '2') {
                this.$callApp(
                  'Android',
                  'OrderPayMethod',
                  JSON.stringify(payData)
                )
                this.$callApp('iOS', 'OrderPayMethod', payData)
                console.log('英航卡11111111111111111111111', payData)
              }
            } else {
              window.location.href = `${FRONTEND_HOST}/themepage/success?id=${
                payData.orderId
              }&zero=${0}`
            }
          }
        })
        .finally(() => loading.clear())
    },
  },
}
</script>

<style scoped lang="less">
.main {
  min-height: 100vh;
  position: relative;
  background-color: #fff;
  .btn {
    position: absolute;
    bottom: 40px;
    text-align: center;
    .btn-content {
      margin-left: 25px;
      width: 325px;
    }
  }
}
.head {
  margin-top: 40px;
  text-align: center;
  .share {
    padding-bottom: 10px;
  }
  /deep/.pay-time {
    margin-left: 110px;
  }
  /deep/.van-count-down {
    line-height: 25px;
    font-size: 15px;
  }
}
.select {
  margin-top: 20px;
  .img-icon {
    width: 23px;
    height: 23px;
    margin-right: 5px;
  }
}
</style>
